<template>
  <div
    class="download"
    :class="{ 'download-mobile': isMobile, row: !isColumn }"
    :style="{ gap: (isMobile ? 16 : gap) + 'px' }"
  >
    <div v-if="!hideIcon">
      <img
        :src="
          isChina
            ? require('@/assets/images/china_hsk_mock_logo_white_bg.png')
            : require('@/assets/images/hsk_mock_logo_white_bg.png')
        "
        :style="{ width: isMobile ? '48px' : '108px', height: isMobile ? '48px' : '108px' }"
      />
    </div>
    <div
      class="clickable download-item android"
      :class="[{ 'download-item-mobile': isMobile }, whiteIcon ? 'android-w' : 'android']"
      @click="handleClick('app-store')"
    ></div>
    <div
      class="clickable download-item"
      :class="[{ 'download-item-mobile': isMobile }, whiteIcon ? 'app-store-w' : 'app-store']"
      :style="{ marginLeft: isMobile ? '0px' : '0px' }"
      @click="handleClick('android')"
      v-if="isChina"
    ></div>
    <div
      class="clickable download-item"
      :class="[{ 'download-item-mobile': isMobile }, whiteIcon ? 'google-play-w' : 'google-play']"
      @click="handleClick('google-play')"
      :style="{ marginLeft: isMobile ? '0px' : '0px' }"
      v-if="!isChina"
    ></div>
  </div>
</template>

<script>
import { IS_CHINA } from '@/config'
export default {
  name: '',
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    whiteIcon: {
      type: Boolean,
      default: false,
    },
    isColumn: {
      type: Boolean,
      default: true,
    },
    gap: {
      type: Number,
      default: 53,
    },
    hideIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    isChina() {
      return IS_CHINA
    },
  },
  methods: {
    handleClick(val) {
      this.$emit('handleClick', val)
    },
  },
}
</script>

<style scoped lang="scss">
.download {
  display: flex;
  align-items: center;
  justify-content: center;
  &-mobile {
    flex-direction: column;
    justify-content: center;
  }
}
.row {
  display: flex;
  align-items: center;

  flex-direction: row;
  gap: 9px;
  .download-item {
    background-repeat: no-repeat;
    background-size: 100% 100%;
    &-mobile {
      width: 82px;
      height: 24px;
      margin-bottom: 0px;
    }
  }

  &::before {
    content: none;
  }
  &::after {
    content: none;
  }
}
.download-item {
  width: 147px;
  height: 48px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  &-mobile {
    width: 137.6px;
    height: 40px;
    // margin-bottom: 16px;
  }

  &.android {
    background-image: url('@/assets/images/home/apple.png');
  }
  &.app-store {
    background-image: url('@/assets/images/home/android.png');
  }
  &.google-play {
    background-image: url('@/assets/images/home/google.png');
  }
  &.android-w {
    background-image: url('@/assets/images/home/apple-w.png');
  }
  &.app-store-w {
    background-image: url('@/assets/images/home/android-w.png');
  }
  &.google-play-w {
    background-image: url('@/assets/images/home/google-w.png');
  }
}
</style>
